import imgix from 'imgix.js';

export default ['$rootScope', '$timeout', ($rootScope, $timeout) => {

    function closestNum (num, arr) {
        let curr = arr[0];
        let key = 0;
        let diff = Math.abs(num - curr);
        for (let val = 0; val < arr.length; val++) {
            let newdiff = Math.abs(num - arr[val]);
            if (newdiff < diff) {
                diff = newdiff;
                curr = arr[val];
                key = val;
            }
        }
        if (num >= curr && key !== (arr.length - 1)) {
            return arr[key + 1];
        }
        return curr;
    }

    let acceptable_sizes = {
        widths: [100, 150, 250, 300, 500, 640, 800, 1000, 1500, 2000, 2560],
        heights: [100, 150, 250, 300, 500, 640, 800, 1000, 1500]
    };

    let imgixFluid = imgix.fluid({
        lazyLoad: true,
        lazyLoadOffsetVertical: 150,
        pixelStep: 50,
        lazyLoadColor: false,
        onChangeParamOverride: function (w, h, params, elem) {
            switch (elem.getAttribute('data-fit')) {
                case 'fit':
                    params.fit = 'clip';
                    break;

                case 'crop':
                    params.fit = 'crop';
                    break;

                default:
                case 'auto':
                    params.fit = 'crop';
                    params.crop = 'faces,edges';
            }

            params.auto = 'format';
            params.ch = 'DPR,Width';
            params.q = 65;
            params.w = closestNum(w, acceptable_sizes.widths).toString();
            params.h = closestNum(h, acceptable_sizes.heights).toString();

            return params;
        },
        onLoad: function (elem) {
            if (!elem.className.match('has-loaded')) {
                elem.classList.add('has-loaded');
            }
        }
    });

    function reload () {
        $timeout(() => imgixFluid.reload());
    }

    $rootScope.$watch('image', function (newVal, oldVal) {
        if (oldVal && oldVal !== newVal) {
            imgixFluid.reload();
        }
    });

    $rootScope.$on("$locationChangeSuccess", function () {
        imgixFluid.reload();
    });

    angular.element(window).on('imgixRefresh', function () {
        imgixFluid.reload();
    });

    return {
        imgixFluid,
        reload
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/services/imgix.service.js